module.exports = __webpack_public_path__ + "img/q_44_sor.a3d781af.png";